/**
 * Connexion (Google, Facebook) partagée par les pages de login Aria et VtM.
 * Crée / met à jour le document `users` puis met à jour le contexte utilisateur.
 */
import firebase from "firebase/compat/app";
import "firebase/compat/analytics";
import "firebase/compat/auth";
import "firebase/compat/firestore";
import {init} from './initFirebase';

init();
const db = firebase.firestore();

export const signIn = async (provider, updateUser) => {
  let authProvider = null;
  if(provider === 'facebook') {
    authProvider = new firebase.auth.FacebookAuthProvider();
  }
  if(provider === 'google') {
    authProvider = new firebase.auth.GoogleAuthProvider();
  }

  try {
    const data = await firebase.auth().signInWithPopup(authProvider)
    const user = {};
    user.uid = data.user.uid;
    if(data.user.email) {
      user.email = data.user.email;
    }
    user.displayName = data.user.displayName;
    user.name = data.user.displayName;
    user.photoURL = data.user.photoURL;
    await db.collection("users").doc(user.uid).set({
      uid: user.uid,
      name: user.displayName,
      authProvider: provider,
      email: user.email || null,
      locale: data.additionalUserInfo.profile.locale || 'en',
      frameUnlock:[],
      ...(data.additionalUserInfo.isNewUser && { createdAt: new Date() }),
    }, { merge: true });
    firebase.analytics().setUserId(user.uid);
    firebase.analytics().setUserProperties({
      name: user.displayName,
      uid: user.uid,
    });
    firebase.analytics().logEvent('Login', {
      authProvider: provider,
    });
    updateUser(user);
  } catch (err) {
    console.log(err);
  }
};
